import React, { useEffect, useState } from 'react';
import { jwtDecode } from 'jwt-decode';
import UserDashboard from './UserDashboard';
import attendanceAPI from '../api/attendanceAPI';

const UserAttendance = () => {
  const [records, setRecords] = useState([]);

  useEffect(() => {
    const fetchAttendance = async () => {
      try {
        const token = localStorage.getItem('token');
        if (!token) {
          alert('User not logged in');
          return;
        }

        const decoded = jwtDecode(token);
        const workerId = decoded.id || decoded._id || decoded.workerId;

        if (!workerId) {
          alert('Worker ID missing in token');
          return;
        }

        const res = await attendanceAPI.get(`/worker/${workerId}`);
        setRecords(res.data);
      } catch (err) {
        console.error('Error fetching attendance:', err);
        alert('Failed to fetch attendance.');
      }
    };

    fetchAttendance();
  }, []);

  const formatDate = (isoDate) => {
    if (!isoDate) return '--';
    const [year, month, day] = isoDate.split('-');
    return `${day}/${month}/${year}`;
  };

  return (
    <div>
      <UserDashboard />
      <div className="min-h-screen bg-gradient-to-br from-purple-100 to-pink-100 pt-20">
        <h2 className="text-3xl font-bold font-mono text-purple-700 mb-6 text-center mt-6">
          Attendance Report
        </h2>

        <div className="max-w-6xl mx-auto">
          <div
            className="overflow-x-auto overflow-y-auto max-h-[500px] bg-white shadow-md rounded-xl" >
            <table className="min-w-full table-auto">
              <thead className="bg-purple-100 text-purple-700 sticky top-0 z-10">
                <tr>
                  <th className="py-3 px-4 text-left font-semibold">Date</th>
                  <th className="py-3 px-4 text-left font-semibold">Profile</th>
                  <th className="py-3 px-4 text-left font-semibold">Name</th>
                  <th className="py-3 px-4 text-left font-semibold">Role</th>
                  <th className="py-3 px-4 text-left font-semibold">Work Mode</th>
                  <th className="py-3 px-4 text-left font-semibold">Login Time</th>
                  <th className="py-3 px-4 text-left font-semibold">Logout Time</th>
                  <th className="py-3 px-4 text-left font-semibold">Total Hours</th>
                  <th className="py-3 px-4 text-left font-semibold">Status</th>
                </tr>
              </thead>
              <tbody className="text-gray-700">
                {records.length > 0 ? (
                  records.map((rec, idx) => (
                    <tr key={idx} className="border-t hover:bg-purple-50 transition">
                      <td className="py-3 px-4">{formatDate(rec.date)}</td>  
                      <td className="py-3 px-4">
                        <img
                      src={rec.workerId.profileImage?.replace(/\\/g, '/')}
                      alt="profile"
                      className="w-10 h-10 rounded-full object-cover"
                    />
                      </td>                    
                      <td className="py-3 px-4">{rec.username}</td>
                      <td className="py-3 px-4">{rec.role}</td>
                      <td className="py-3 px-4">{rec.workMode}</td>
                      {/* <td className="py-3 px-4">{rec.loginTime || '--'}</td>
                      <td className="py-3 px-4">{rec.logoutTime || '--'}</td> */}
                      <td className="py-3 px-4">
  {rec.sessions && rec.sessions.length > 0 ? (
    <ul>
      {rec.sessions.map((s, i) => (
        <li key={i}>{s.loginTime || '--'}</li>
      ))}
    </ul>
  ) : '--'}
</td>

<td className="py-3 px-4">
  {rec.sessions && rec.sessions.length > 0 ? (
    <ul>
      {rec.sessions.map((s, i) => (
        <li key={i}>{s.logoutTime || '--'}</li>
      ))}
    </ul>
  ) : '--'}
</td>
                      <td className="py-3 px-4">{rec.totalHours || '--'}</td>
                      <td
                        className={`py-3 px-4 font-semibold ${
                          rec.status === 'Present' ? 'text-green-600' : 'text-red-500'
                        }`}
                      >
                        {rec.status}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="8" className="text-center py-6 text-gray-500">
                      No attendance records found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserAttendance;
